import { OrderStatusViewModel } from '@spa/components/organisms/mypage/order/model/order-status-view'
import CvsStatusView from '@spa/components/organisms/mypage/order/state/CvsStatusView.vue'
import DefaultStatusView from '@spa/components/organisms/mypage/order/state/DefaultStatusView.vue'
import { Order } from '@spa/store/modules/orderHistory/types'
import Vue, { VueConstructor } from 'vue'

export function selectOrderStateView(order: Order, status: OrderStatusViewModel) {
  const wrapper = (() => {
    switch (order.payment.method.kind) {
      case 'cvs-number':
        return buildWrapperFor(CvsStatusView)
      default:
        return buildWrapperFor(DefaultStatusView)
    }
  })()

  return wrapper(order, status)
}

function buildWrapperFor(statusView: VueConstructor) {
  return (order: Order, status: OrderStatusViewModel): VueConstructor =>
    Vue.extend({
      name: `${ statusView.name }Wrapper`,
      components: { statusView },
      data: () => ({ order, status }),
      template: '<status-view :order="order" :status-view="status" />',
    })
}
